import React from "react";
import { Link } from "react-router-dom";
import "./GeneralPageStyle.css";
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
/*import Draft, { rawToDraft, draftToRaw } from 'react-wysiwyg-typescript';*/
import Draft, { /*htmlToDraft, draftToHtml, EmptyState, */rawToDraft, draftToRaw /*, draftStateToHTML*/} from 'react-wysiwyg-typescript';
import { MuiThemeProvider, createTheme } from '@material-ui/core/styles';
import Switch from '@material-ui/core/Switch';
import config from "../../../../resources/config.json";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Grid from '@material-ui/core/Grid';

const Switch_Theme = createTheme({
    palette: {
        primary: { main: config.defaultSecondaryClr }
    }
});

export default class GeneralPageComponent extends React.Component{
    constructor(props){
        super(props);
        this.state = {editorState: '', title: '', settings: {}, ishtml: false, enableDocUpload: false};
    }
    componentDidUpdate = (prevProps) => {
        if (prevProps.data !== this.props.data) {
            this.setState({
                title: this.props.data.title, 
                settings: this.props.data.settings, 
                editorState: this.props.data.settings.footerText
                ? this.props.data.settings.footerText.content
                ? rawToDraft(this.props.data.settings.footerText.content)
                : rawToDraft(this.props.data.settings.footerText)
                : null,
                ishtml: this.props.data.settings.footerText ? this.props.data.settings.footerText.isHtml ? this.props.data.settings.footerText.isHtml : false : false,
                enableDocUpload: this.props.data.settings.enableDocUpload ? this.props.data.settings.enableDocUpload : false
            });
        }
    }
    onInputChange = (event) => {
        this.props.handleDataChange();
        let _tempVar = this.state;
        if(event.target.name === 'title')
            _tempVar.title = event.target.value;
        else 
            _tempVar.settings[event.target.name] = event.target.value;
             this.setState(_tempVar);

    }

    handleSwitchChange = (event) => {
        this.setState({ ishtml: event.target.checked });
    }
    handleEnableDocUploadChange = (event) => {
        this.props.handleDataChange();
        this.setState({ enableDocUpload: event.target.checked });
    }

    saveGeneral = (event, data) => {
        event.preventDefault();
        
        // Validate upload doc URL if enableDocUpload is true
        if (this.state.enableDocUpload && (!this.state.settings.uploadDocUrl || this.state.settings.uploadDocUrl.trim() === '')) {
            this.props.showNotification('error', 'Upload Doc URL is required when Document Upload is enabled.');
            return;
        }
        
        let _tempVar = this.state;
        try{
            _tempVar.settings.footerText ={
                content:  draftToRaw(this.state.editorState),
                isHtml: this.state.ishtml
            };
        }catch(e){
            console.error(e);
        }
        _tempVar.settings.enableDocUpload = this.state.enableDocUpload;
        this.setState(_tempVar, () => {
            this.props.saveSettings(this.state.title, this.state.settings);
        });
        
        /*console.log(draftToRaw(this.state.editorState));*/
        /*console.log(footerContentObj.innerHTML);*/
        /*try{
            console.log(htmlToDraft(this.state.editorState));
        }catch(e){
            console.error(e)
        }
        try{
            console.log(draftToHtml(this.state.editorState));
        }catch(e){
            console.error(e)
        }
        try{
            console.log(rawToDraft(this.state.editorState));
        }catch(e){
            console.error(e)
        }*/
//        try{
//            console.log(draftToRaw(this.state.editorState));
//            console.log(rawToDraft(draftToRaw(this.state.editorState)));
//            console.log(draftStateToHTML(draftToRaw(this.state.editorState)));
//            console.log(draftToHtml(draftToRaw(this.state.editorState)));
//        }catch(e){
//            console.error(e)
//        }
        /*try{
            console.log(draftStateToHTML(this.state.editorState));
        }catch(e){
            console.error(e)
        }*/
        
        /*console.log(JSON.stringify(this.state.editorState));*/
    }
    render(){
        return(
            <div className="generalPage">
                <form autoComplete="off" onSubmit={this.saveGeneral}>
                    <TextField label="Site Title" margin="normal" fullWidth required={true} name="title" value={this.state.title ? this.state.title:''} onChange={this.onInputChange} />
                    <TextField label="App Submit URL" margin="normal" helperText="Input the URL that your applications will be submitted to" fullWidth required={true} name="submitUrl" value={this.state.settings.submitUrl ? this.state.settings.submitUrl:''} onChange={this.onInputChange} />
                    <TextField label="App Update URL" margin="normal" helperText="Input the URL that your updated applications will be submitted to" fullWidth required={false} name="updateUrl" value={this.state.settings.updateUrl ? this.state.settings.updateUrl:''} onChange={this.onInputChange} />
                    <TextField label="Source System Code" margin="normal" helperText="Input the Source System Code here" fullWidth required={true} name="ssc" value={this.state.settings.ssc ? this.state.settings.ssc:''} onChange={this.onInputChange} />
                    <TextField label="Client Dealer ID" margin="normal" helperText="Input your Client Dealer ID here" fullWidth required={true} name="dealerId" value={this.state.settings.dealerId ? this.state.settings.dealerId:''} onChange={this.onInputChange} />
                    
                    <hr className="divider" />
                    <Grid container className="uploadDocContainer" style={{ margin: '20px 0'}}>
                        <Grid item xs={12}>
                            <MuiThemeProvider theme={Switch_Theme}>
                                <FormControlLabel 
                                    control={<Switch className="toggleBtn" color="primary" checked={this.state.enableDocUpload} onChange={this.handleEnableDocUploadChange} />}
                                    label="Document Upload" 
                                    labelPlacement="start" 
                                />
                            </MuiThemeProvider>
                        </Grid>
                        {this.state.enableDocUpload && (
                            <Grid item xs={12}>
                                <TextField 
                                    label="Upload Doc URL" 
                                    margin="normal" 
                                    helperText="Input the URL that your uploaded documents will be submitted to" 
                                    fullWidth 
                                    required={true} 
                                    name="uploadDocUrl" 
                                    value={this.state.settings.uploadDocUrl ? this.state.settings.uploadDocUrl:''} 
                                    onChange={this.onInputChange} 
                                    InputLabelProps={{ shrink: true }} 
                                />
                            </Grid>
                        )}
                    </Grid>
                    <hr className="divider" />
                    <div className="footerSwitchCnt">
                        <span>Site Footer Text</span>
                        <MuiThemeProvider theme={Switch_Theme}>
                            <FormControlLabel 
                                control={<Switch className="toggleBtn" color="primary" checked={this.state.ishtml} onChange={this.handleSwitchChange} />}
                                label="HTML" 
                                labelPlacement="start" 
                            />
                        </MuiThemeProvider>
                    </div>
                    <Draft id="_draftEditor"
                        editorState={this.state.editorState}
                        onEditorStateChange={(editorState) => { this.props.handleDataChange();this.setState({ editorState }); }}
                        toolbar ={
                            {
                                options:['inline', 'blockType', 'fontSize', 'list', 'history', 'textAlign', 'colorPicker', 'link' ], 

                                fontSize: {
                                    options: ["8", "10", "12", "14", "16", "18", "20", "22", "24", "26", "28", "30", "32", "34", "36", "38", "40", "44", "48", "52", "56", "60", "70", "80", "90"]
                                },
                                link: {defaultTargetOption: '_blank'} 
                            }                                                       
                        }
                    />
                    <div className="footerBtnCnt">
                        <Button className="cancelBtn appSecondaryClr">
                            <Link to="/main/sites">Cancel</Link>
                        </Button>
                        <Button type="submit" variant="contained" className="saveBtn appSecondaryBGClr">Save Settings</Button>
                    </div>
                </form>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/admin/components/Main/SettingsPage/General/GeneralPage.js